import { Container } from "react-bootstrap";
import ParticipantRow from "../ParticipantRow";

const ParticipantsList = ({ participants = [] }) => {
  return (
    <Container className="pt-4">
      {
        participants.map((p) => (
          <ParticipantRow
            id={p.id}
            name={p.name}
            programHistory={p.programs}
            status={"Active"}
          />
        ))
      }

      <ParticipantRow />
      <ParticipantRow />
    </Container>
  );
};

export default ParticipantsList;
